"use client";

import { useMobileNav } from "@/contexts/MobileNavContext";

interface MobileNavProps {
  onMenuClick: () => void;
}

/**
 * 移动端顶部导航栏
 * - 左侧：汉堡菜单（或返回按钮）
 * - 中间：页面标题或 Logo
 * - 右侧：动态操作区（由各页面提供）
 */
export function MobileNav({ onMenuClick }: MobileNavProps) {
  const { title, leftActions, rightActions, showBackButton, onBack } = useMobileNav();

  return (
    <header className="h-14 bg-[#1a1a1a] border-b border-[#2a2a2a] flex items-center px-3 lg:hidden">
      {/* 左侧：菜单按钮 + 动态操作区 */}
      <div className="flex items-center gap-1">
        {showBackButton && onBack ? (
          <button
            onClick={onBack}
            className="w-10 h-10 flex items-center justify-center rounded-lg hover:bg-[#2a2a2a] transition-colors"
            aria-label="返回"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 text-[#e5e5e5]"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </button>
        ) : (
          <button
            onClick={onMenuClick}
            className="w-10 h-10 flex items-center justify-center rounded-lg hover:bg-[#2a2a2a] transition-colors"
            aria-label="打开菜单"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 text-[#e5e5e5]"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </button>
        )}
        {/* 左侧动态操作区 */}
        {leftActions}
      </div>

      {/* 中间：标题 */}
      <div className="flex-1 flex items-center justify-center min-w-0 px-2">
        {title && (
          <h1 className="text-base font-medium text-[#e5e5e5] truncate">{title}</h1>
        )}
      </div>

      {/* 右侧：动态操作区 */}
      <div className="flex items-center gap-1">
        {rightActions || <div className="w-10" />}
      </div>
    </header>
  );
}
